const historyPageState = (state) => state.historyPage

export const historyPageSelectors = {
    activeTab: (state) => historyPageState(state).activeTab,
    selectedGroupId: (state) => historyPageState(state).selectedGroupId,
    selectedGroupName: (state) => historyPageState(state).selectedGroupName,
    saveOnServer: (state) => historyPageState(state).saveOnServer,
    activeVersionId: (state) => historyPageState(state).activeVersionId,
    versionTable: (state) => historyPageState(state).versionTable,
    activeVersion: (state) => {
        const activeVersionId = historyPageState(state).activeVersionId
        if (!activeVersionId) return null

        return state.history.versions.find(
            (version) => version.version_id === activeVersionId
        ) || null
    },
}
